import ToastError from '@atoms/ToastError';
import ToastSuccess from '@atoms/ToastSuccess';
import ToastWarning from '@atoms/ToastWarning';
import React from 'react';

type ToastPlacement = 'top' | 'bottom' | 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';

interface CustomToastProps {
  toast: any;
  renderComponent: React.ReactNode;
  id: string;
  placement?: ToastPlacement;
  duration?: number;
}

const activeToasts = new Set<string>();
const maxToasts = 3;

// Export function to clear active toasts for testing
export function clearActiveToasts(): void {
  activeToasts.clear();
}

// Export the activeToasts Set for testing
export { activeToasts };

export function showCustomToast({
  toast,
  renderComponent,
  id,
  placement = 'top',
  duration = 5000,
}: CustomToastProps): void {
  if (activeToasts.has(id)) return;

  if (activeToasts.size >= maxToasts) {
    const first = activeToasts.values().next().value;
    activeToasts.delete(first);
  }

  activeToasts.add(id);

  toast.show({
    render: () => renderComponent,
    placement,
    duration,
    onCloseComplete: () => {
      activeToasts.delete(id);
    },
  });
}

export function showSuccessToast(toast: any, message: string, id: string, placement?: any, duration?: any): void {
  showCustomToast({
    toast,
    renderComponent: <ToastSuccess data={message} />,
    id,
    placement,
    duration,
  });
}

export function showWarningToast(toast: any, message: string, id: string): void {
  showCustomToast({
    toast,
    renderComponent: <ToastWarning data={message} />,
    id,
  });
}

export function showErrorToast(toast: any, message: string, id: string, customStyle: Record<string, any> = {}): void {
  showCustomToast({
    toast,
    renderComponent: <ToastError data={message} customStyle={customStyle} />,
    id,
  });
}
